import React from "react";
import { Grid2 as Grid, Link } from "@mui/material";
import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import UITypography from "../ui/UITypography";

function Footer() {
  const classes = useStyles();
  const links: any[] = [];
  const content1 = null;
  const content2 = null;

  return (
    <footer className={classes.root} data-testid="footer">
      <Grid>
        {links.map((link: any, i: number) => (
          <React.Fragment key={link.label || i}>
            <Link variant="caption" color="inherit" href={link.url || undefined} underline="hover">
              {link.label}
            </Link>
            {i !== links.length - 1 && <UITypography variant="caption"> | </UITypography>}
          </React.Fragment>
        ))}
      </Grid>
      <Grid>
        {Boolean(content1) && (
          <UITypography variant="caption">
            {content1}
            <br />
          </UITypography>
        )}
        {Boolean(content2) && <UITypography variant="caption">{content2}</UITypography>}
      </Grid>
    </footer>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "transparent",
      borderTop: `1px solid ${theme.palette.grey[100]}`,
      color: theme.palette.text.secondary,
      textAlign: "center",
      padding: theme.spacing(2),
      "& > div": {
        padding: theme.spacing(1),
      },
    },
  })
);

export default Footer;
